<ng-container *transloco="let t">
  <div class="empty-state">
    <div class="d-flex flex-column align-items-center justify-content-center p-5">
      <h1>{{ t('emptyState.not.in.progress') }}</h1>
      <p class="medium pt-2">{{ t('emptyState.not.in.progress.try.later') }}</p>
    </div>
  </div>
</ng-container>
